/** @jsxImportSource @emotion/react */
import * as React from "react";
import { css, SerializedStyles } from "@emotion/react";
import ModalView, { ModalContent } from "../../layout/modal/ModalView";
import { Column, Row } from "../../layout/flexbox";
import * as Buttons from "./buttons";
import { COLUMN_SPACING, ROW_SPACING } from "../styles";
import { MediumText } from "../../styles/styles";
import ModalTitleHeader from "../../layout/modal/ModalTitleHeader";
import { StyledBoxedMessage } from "./boxedMessage/StyledBoxedMessage";

/**
 * ConfirmationModal: a component that displays a message, a positive button, and a negative button.
 * The positive and negative buttons trigger functionality that is passed in via the props.
 * Useful for displaying messages asking for confirmation on certainty of an action.  e.g. 'Are you sure you want to do
 * that?'
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class ConfirmationModal extends React.PureComponent<{
  title: string;
  icon?: any;
  message: React.ReactNode;
  styledMessage?: React.ReactNode;
  style?: any;
  positiveButtonText: string;
  negativeButtonText?: string;
  positiveButtonTitle?: string;
  negativeButtonTitle?: string;
  onPositiveButtonClick: () => void;
  onNegativeButtonClick?: () => void;
  onDismiss: () => void;
  rootCss?: SerializedStyles;
  resources: Record<string, any>;
}> {
  public render = () => (
    <ModalView onDismiss={this.props.onDismiss} rootCss={this.props.rootCss}>
      <ModalTitleHeader
        resources={this.props.resources}
        heading={this.props.title}
        icon={this.props.icon}
        onDismiss={this.props.onDismiss}
      />
      <ModalContent
        css={css`
          min-height: 200px;
        `}
      >
        <Column
          flexGrow={1}
          rootCss={css`
            ${COLUMN_SPACING} min-height:200px;
          `}
        >
          {this.props.styledMessage && this.props.style && (
            <StyledBoxedMessage
              message={this.props.styledMessage}
              boxStyle={this.props.style}
            />
          )}

          <div
            css={css`
              ${MediumText};
            `}
          >
            {this.props.message}
          </div>

          <Row
            alignItems="baseline"
            justifyContent="flex-end"
            rootCss={ROW_SPACING}
          >
            {this.props.negativeButtonText && (
              <Buttons.BigSecondary
                type="button"
                onClick={this.props.onNegativeButtonClick}
                title={this.props.negativeButtonTitle}
              >
                {this.props.negativeButtonText}
              </Buttons.BigSecondary>
            )}
            <Buttons.BigNeutral
              type="button"
              onClick={this.props.onPositiveButtonClick}
              title={this.props.positiveButtonTitle}
            >
              {this.props.positiveButtonText}
            </Buttons.BigNeutral>
          </Row>
        </Column>
      </ModalContent>
    </ModalView>
  );
}
